<!-- CANVAS START-->
<div id="canvasTicketHolder">
  <canvas id="ticketMachineCanvas" width="768" height="1024"></canvas>
</div>
<!-- CANVAS END-->
